import { createReducer, INITIAL_STATE } from '../../../shared/redux';

import { API_INTEGRATE_URL, API_GET_DATA_URL } from './loja-integrada.constants';

export const LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_CALLED = '@integrations/loja-integrada/SAVE_INTEGRATION_REQUEST_CALLED';
export const LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_START = '@integrations/loja-integrada/SAVE_INTEGRATION_REQUEST_START';
export const LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_SUCCESS = '@integrations/loja-integrada/SAVE_INTEGRATION_REQUEST_SUCCESS';
export const LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_ERROR = '@integrations/loja-integrada/SAVE_INTEGRATION_REQUEST_ERROR';
export const LOJA_INTEGRADA_GET_DATA_REQUEST_CALLED = '@integrations/loja-integrada/GET_DATA_REQUEST_CALLED';
export const LOJA_INTEGRADA_GET_DATA_REQUEST_START = '@integrations/loja-integrada/GET_DATA_REQUEST_START';
export const LOJA_INTEGRADA_GET_DATA_REQUEST_SUCCESS = '@integrations/loja-integrada/GET_DATA_REQUEST_SUCCESS';
export const LOJA_INTEGRADA_GET_DATA_REQUEST_ERROR = '@integrations/loja-integrada/GET_DATA_REQUEST_ERROR';

export const getLojaIntegradaState = state => ({
    ...state.integrations.lojaIntegrada,
});

type LojaIntegradaintegrationData = {
    apiToken: string
    clientId: string
}

export const saveLojaIntegradaIntegration = ({
    apiToken,
    clientId,
}:LojaIntegradaintegrationData) => ({
    type: LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_CALLED,
    actionTypes: {
        start: LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_START,
        fail: LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_ERROR,
        success: LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_SUCCESS,
    },
    config: {
        url: API_INTEGRATE_URL,
        method: 'POST',
        data: {
            api_token: apiToken,
            client_id: clientId,
        },
    },
});

export const getLojaIntegradaData = ({ clientId }) => ({
    type: LOJA_INTEGRADA_GET_DATA_REQUEST_CALLED,
    actionTypes: {
        start: LOJA_INTEGRADA_GET_DATA_REQUEST_START,
        success: LOJA_INTEGRADA_GET_DATA_REQUEST_SUCCESS,
        fail: LOJA_INTEGRADA_GET_DATA_REQUEST_ERROR,
    },
    config: {
        url: API_GET_DATA_URL,
        method: 'GET',
        params: {
            client_id: clientId,
        },
    },
});

export type State = {
  loading: boolean
  submitting: boolean
  integrationData: string
};

const initialState: State = {
    loading: true,
    submitting: false,
    integrationData: '',
};

export const lojaIntegradaReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_START]: (state: State): State => ({
        ...state,
        submitting: true,
    }),
    [LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_SUCCESS]: (state: State): State => ({
        ...state,
        submitting: false,
    }),
    [LOJA_INTEGRADA_SAVE_INTEGRATION_REQUEST_ERROR]: (state: State): State => ({
        ...state,
        submitting: false,
    }),
    [LOJA_INTEGRADA_GET_DATA_REQUEST_START]: (state: State): State => ({
        ...state,
        loading: true,
    }),
    [LOJA_INTEGRADA_GET_DATA_REQUEST_SUCCESS]: (state: State, action): State => ({
        ...state,
        loading: false,
        integrationData: action.payload.data.api_token,
    }),
    [LOJA_INTEGRADA_GET_DATA_REQUEST_ERROR]: (state: State): State => ({
        ...state,
        loading: false,
    }),
});
